import cleanedFilename from '~/util/cleanedFilename';

export default {
  FIELD_DROPDOWN: `${cleanedFilename(__filename)}-field-dropdown`,
  AND_OR_COMPONENT: `${cleanedFilename(__filename)}-and-or-component`,
};
